module.exports = __webpack_public_path__ + "static/media/3d_scans.ec5f6832.png";